import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCalendarCircleMinus } from '@fortawesome/pro-light-svg-icons/faCalendarCircleMinus';
import { faCalendarCirclePlus } from '@fortawesome/pro-light-svg-icons/faCalendarCirclePlus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Dropdown, DropdownItem } from 'src/shared/components/dropdown';
import { Icon } from 'src/shared/components/icon';
import BulkActionButton from './bulkActionButton';
import * as styles from './bulkDrippingButton.module.css';
function handleOpen() {
    window.dispatchEvent(new Event('app-content-admin:bulkactionsmenu:create-dripping'));
}
function handleClose() {
    window.dispatchEvent(new Event('app-content-admin:bulkactionsmenu:delete-dripping'));
}
export function BulkDrippingButton() {
    const { t } = useTranslation();
    return (_jsxs(Dropdown, { className: clsx(styles.dropdown, 'flex-[0_0_calc(50%-2px)] md:flex-initial'), position: "top", controls: _jsx(BulkActionButton, { icon: _jsx(Icon, { icon: faCalendarCirclePlus }), className: "w-full", children: t('module_list.bulk.schedule.action') }), children: [_jsx(DropdownItem, { title: t('module_list.bulk.schedule.new'), icon: _jsx(FontAwesomeIcon, { icon: faCalendarCirclePlus }), onClick: handleOpen }), _jsx(DropdownItem, { title: t('module_list.bulk.schedule.remove'), className: "text-danger-500", icon: _jsx(FontAwesomeIcon, { icon: faCalendarCircleMinus }), onClick: handleClose })] }));
}
